import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=bf142078&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=bf142078&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf142078",
  null
  
)

export default component.exports